import { cn } from '@/shared/lib/utils'

interface LogoProps {
  className?: string
}

export function Logo({ className }: LogoProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-5 w-5', className)}
    >
      {/* Left bracket < */}
      <path
        d="M10 8L4 16L10 24"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Right bracket > */}
      <path
        d="M22 8L28 16L22 24"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Left eye (empty circle) */}
      <circle cx="12.5" cy="14" r="2" stroke="currentColor" strokeWidth="1.5" fill="none" />

      {/* Right eye (empty circle) */}
      <circle cx="19.5" cy="14" r="2" stroke="currentColor" strokeWidth="1.5" fill="none" />

      {/* Mouth (dot) */}
      <circle cx="16" cy="21" r="1.5" fill="currentColor" />
    </svg>
  )
}
